import { defineComponent as _defineComponent } from 'vue'
interface Props {
    text: string
    permanent?: boolean
    dangerouslySetInnerHtml?: boolean
    position?: 'top' | 'bottom' | 'left' | 'right'
    expand?: boolean
    disabled?: boolean
    displayBlock?: boolean
    cursor?: 'help' | 'not-allowed'
    color?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'tm-tooltip',
  props: {
    text: null,
    permanent: { type: Boolean },
    dangerouslySetInnerHtml: { type: Boolean },
    position: null,
    expand: { type: Boolean },
    disabled: { type: Boolean },
    displayBlock: { type: Boolean },
    cursor: null,
    color: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})